module.exports = __webpack_public_path__ + "static/media/abhee-nandana.6c9fa28a.png";